import { render, staticRenderFns } from "./userLayout.vue?vue&type=template&id=bf2bd28c&scoped=true&"
import script from "./userLayout.vue?vue&type=script&lang=js&"
export * from "./userLayout.vue?vue&type=script&lang=js&"
import style0 from "./userLayout.vue?vue&type=style&index=0&id=bf2bd28c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2bd28c",
  null
  
)

export default component.exports